export interface LoginAttemptResponse {
  currentTry: number;
  maxTry: number;
}

export function isLoginAttemptResponse(
  value: unknown
): value is LoginAttemptResponse {
  return (
    typeof value === 'object' &&
    value !== null &&
    'currentTry' in value &&
    'maxTry' in value &&
    typeof (value as any).currentTry === 'number' &&
    typeof (value as any).maxTry === 'number'
  );
}
